import { render, staticRenderFns } from "./rankTable.vue?vue&type=template&id=cb2c2026"
import script from "./rankTable.vue?vue&type=script&lang=js"
export * from "./rankTable.vue?vue&type=script&lang=js"
import style0 from "./rankTable.vue?vue&type=style&index=0&id=cb2c2026&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports